/*
 * ll-money.js — shared currency-aware money formatter.
 *
 * Exposes window.LLMoney so any storefront script can turn minor units
 * (integer cents) into a display string without hard-coding a "$" sign.
 * Loaded once in theme.liquid, before any script that formats prices.
 */
(function () {
  "use strict";

  var FALLBACK_SYMBOLS = { GBP: "£", USD: "$" };

  function addThousandsSeparators(integerPart) {
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function manualFormat(cents, currencyCode) {
    var symbol = FALLBACK_SYMBOLS[currencyCode] || currencyCode + " ";
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split(".");
    parts[0] = addThousandsSeparators(parts[0]);
    return symbol + parts.join(".");
  }

  function currency() {
    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) {
      return window.Shopify.currency.active;
    }
    var pageCurrency = document.documentElement.getAttribute("data-ll-currency");
    return pageCurrency || "GBP";
  }

  function format(cents, currencyCode) {
    var code = currencyCode || currency();
    var locale = document.documentElement.lang || "en";
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: code,
        currencyDisplay: "narrowSymbol",
      }).format(cents / 100);
    } catch (err) {
      return manualFormat(cents, code);
    }
  }

  window.LLMoney = {
    currency: currency,
    format: format,
  };
})();
